
<div class = "container">
  <h3>{{hanger?.name}}</h3>
  <div class= "lineInfo">
    @if (showImage) {
      <div class="image">
        <img src="{{imageUrl}}" alt="" defaultImg>
      </div>
    }
    <div [innerHTML]="hanger.description" id="tinymce">
    </div>
  </div>
</div>
